import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { CalculateCoverResponse } from 'src/app/models/calculate-cover-response';
import { QQQuestionnaireViewModel } from 'src/app/models/qq-questionnaire.view-model';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { QuestionnaireService } from 'src/app/services/questionnaire.service';

@Component({
  selector: 'apg-cover-calculator',
  templateUrl: './apg-cover-calculator.component.html',
  styleUrls: ['./apg-cover-calculator.component.scss'],
})
export class ApgCoverCalculatorComponent implements OnInit {

  @Input() name = 'CoverCalculator';
  @Input() quickQuoteUrl: string;
  @Output() continue = new EventEmitter<CalculateCoverResponse>();
  @Output() back = new EventEmitter();

  @ViewChild(NgForm) form: NgForm;

  questionnaire: QQQuestionnaireViewModel;

  constructor(
    private questionnaireService: QuestionnaireService,
    private analyticsService: AnalyticsService
  ) { }

  async ngOnInit() {
    this.questionnaire = await this.questionnaireService.getQuestionnaireViewModel(this.name, false);
    this.questionnaire.initialScreen = false;
  }

  onVisible() {
    this.analyticsService.logPageView('cover_calculator', { page_title: 'Cover Calculator' });
  }

  proceed(result: CalculateCoverResponse) {
    result = { ...result };
    result.sumAssured = Math.min(result.sumAssured, 1000000);
    if (this.quickQuoteUrl) {
      window.location.href = `${this.quickQuoteUrl}?CoverBasis=${result.coverBasis}&SumAssured=${result.sumAssured}&Term=${result.term}`;
    }
    else
      this.continue.next(result);
  }
}
